export default {
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    classButtonList: {
      type: [Array, String],
    },
    type: {
      type: String,
      required: true,
    },
  },
}
